import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'DECIDI COSA FARE',
        description:
            "Premi 'Esporta' per generare i Word o i PDF della verifica. Premi 'Modifica' per partire dalla verifica selezionata e salvare in seguito la tua versione. Puoi anche aggiungere la verifica ai preferiti per ritrovarla più velocemente.",
        name: 'EditorialHomeworkPageAnchor',
        tutorialName: 'dettaglio-verifica_pulsantiera'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'top',
        xPlacement: 'CENTER',
        yPlacement: 'MIDDLE'
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'top',
        xOffset: 5
    }
};
